// extracted by mini-css-extract-plugin
export default {"navigation":"v_adsH","breadcrumbs":"ujHWxY","shortBreadcrumbs":"xqn0K9","historicalBreadcrumbs":"SR2Dyv","shortBreadcrumbsRTL":"jk2hMh","shortBreadcrumbsRtl":"jk2hMh"};